import { create } from 'zustand';
import { GalleryItem } from '../types/gallery';
import type { ImageAnnotation } from '../types/order';

/**
 * Contexto opcional carregado junto com `editingImage` quando o editor rápido
 * é aberto a partir de uma imagem de OUTPUT de PEDIDO (em vez da galeria).
 * Faz o QuickEditModal chamar o endpoint dedicado do pedido (assíncrono)
 * em vez do editor genérico da galeria.
 */
export interface OrderEditContext {
  orderId: string;
  itemId: string;
  orderImageId: string;
  /** Pins do cliente na imagem (revisão/reprovação) — exibidos no editor. */
  pins?: ImageAnnotation[];
  /** Chamado após o 202 pra o pedido recarregar e mostrar a nova versão. */
  onQueued?: () => void;
}

interface GenerationState {
  homePageResult: GalleryItem | null;
  isLoading: boolean;
  error: string | null;
  prompt: string;
  editingImage: GalleryItem | null;
  /** Contexto de pedido do `editingImage` atual (null fora do fluxo de pedido). */
  editingImageOrderContext: OrderEditContext | null;
  videoCreationItem: GalleryItem | null;

  // Actions
  setHomePageResult: (item: GalleryItem | null) => void;
  setIsLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setPrompt: (prompt: string) => void;
  // `orderContext` é aditivo e opcional: chamadores existentes (galeria, moodboard,
  // etc.) continuam passando só a imagem — o contexto de pedido é sempre limpo
  // (null) quando omitido, pra nunca vazar de uma sessão de edição de pedido
  // anterior pra um editingImage genérico seguinte.
  setEditingImage: (image: GalleryItem | null, orderContext?: OrderEditContext | null) => void;
  setVideoCreationItem: (item: GalleryItem | null) => void;
}

export const useGenerationStore = create<GenerationState>((set) => ({
  homePageResult: null,
  isLoading: false,
  error: null,
  prompt: 'modelo vestindo a peça, fundo branco, iluminação profissional, estilo e-commerce',
  editingImage: null,
  editingImageOrderContext: null,
  videoCreationItem: null,

  setHomePageResult: (item) => set({ homePageResult: item }),
  setIsLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),
  setPrompt: (prompt) => set({ prompt }),
  setEditingImage: (image, orderContext) =>
    set({ editingImage: image, editingImageOrderContext: orderContext ?? null }),
  setVideoCreationItem: (item) => set({ videoCreationItem: item }),
}));
